document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.amc-price-list');
    if (!section) return;

    const tabs = section.querySelectorAll('.amc-price-list__tab');
    const panels = section.querySelectorAll('.amc-price-list__panel');

    // Tab switching functionality with fade in/out
    const panelsWrapper = section.querySelector('.amc-price-list__panels');
    const transitionDuration = 250;

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const targetId = tab.getAttribute('data-tab-target');
            const targetPanel = section.querySelector(`#${targetId}`);
            const currentPanel = section.querySelector('.amc-price-list__panel--active');

            if (!targetPanel || targetPanel === currentPanel) return;

            // Prevent layout jump: set min-height to current content height
            if (panelsWrapper && currentPanel) {
                panelsWrapper.style.minHeight = currentPanel.offsetHeight + 'px';
            }

            // Remove active from current panel (fade out)
            tabs.forEach(t => {
                t.classList.remove('amc-price-list__tab--active');
                t.setAttribute('aria-selected', 'false');
            });
            panels.forEach(p => p.classList.remove('amc-price-list__panel--active'));

            // Update tab state immediately
            tab.classList.add('amc-price-list__tab--active');
            tab.setAttribute('aria-selected', 'true');
            targetPanel.classList.add('amc-price-list__panel--active');

            // Clear min-height after transition so new panel height takes over
            setTimeout(() => {
                if (panelsWrapper) {
                    panelsWrapper.style.minHeight = '';
                }
            }, transitionDuration);

            // Show/hide search bar for active tab and clear search
            const searchWrappers = section.querySelectorAll('.amc-price-list__search-wrapper');
            searchWrappers.forEach(wrapper => {
                const searchTabId = wrapper.getAttribute('data-search-for-tab');
                if (searchTabId === targetId) {
                    wrapper.classList.remove('amc-price-list__search-wrapper--hidden');
                    // Clear search input for newly active tab
                    const searchInputInWrapper = wrapper.querySelector('.amc-price-list__search');
                    if (searchInputInWrapper) {
                        searchInputInWrapper.value = '';
                    }
                } else {
                    wrapper.classList.add('amc-price-list__search-wrapper--hidden');
                }
            });

            // Reset all rows visibility in the new active panel
            if (targetPanel) {
                const rows = targetPanel.querySelectorAll('.amc-price-list__tbody tr');
                rows.forEach(row => {
                    row.style.display = '';
                });
            }
        });
    });

    // Helper function to perform search
    function performSearch(searchInput) {
        const searchTerm = searchInput.value.toLowerCase();
        const searchWrapper = searchInput.closest('.amc-price-list__search-wrapper');
        const mobileTopBar = searchInput.closest('.amc-price-list__mobile-top-bar');
        
        let targetPanel;
        
        if (searchWrapper) {
            const targetTabId = searchWrapper.getAttribute('data-search-for-tab');
            targetPanel = section.querySelector(`#${targetTabId}`);
        } else if (mobileTopBar) {
            targetPanel = mobileTopBar.closest('.amc-price-list__panel');
        }

        if (!targetPanel) return;

        const rows = targetPanel.querySelectorAll('.amc-price-list__tbody tr');
        rows.forEach(row => {
            const text = row.textContent.toLowerCase();
            if (text.includes(searchTerm)) {
                row.style.display = '';
            } else {
                row.style.display = 'none';
            }
        });
    }

    // Mobile search functionality - search as you type
    const mobileSearchInputs = section.querySelectorAll('.amc-price-list__mobile-top-bar .amc-price-list__search');
    mobileSearchInputs.forEach(searchInput => {
        searchInput.addEventListener('input', (e) => {
            performSearch(e.target);
        });
    });

    // Desktop search functionality - search on button click
    const searchButtons = section.querySelectorAll('.amc-price-list__search-btn');
    searchButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const searchWrapper = button.closest('.amc-price-list__search-wrapper');
            const searchInput = searchWrapper.querySelector('.amc-price-list__search');
            if (searchInput) {
                performSearch(searchInput);
            }
        });
    });

    // Desktop search - also allow Enter key
    const desktopSearchInputs = section.querySelectorAll('.search-wrapper:not(.amc-price-list__mobile-top-bar .amc-price-list__search-wrapper) .amc-price-list__search');
    desktopSearchInputs.forEach(searchInput => {
        searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                performSearch(e.target);
            }
        });
        
        // Reset table when input is cleared
        searchInput.addEventListener('keyup', (e) => {
            if (e.target.value.trim() === '') {
                const searchWrapper = e.target.closest('.amc-price-list__search-wrapper');
                if (searchWrapper) {
                    const targetTabId = searchWrapper.getAttribute('data-search-for-tab');
                    const targetPanel = section.querySelector(`#${targetTabId}`);
                    if (targetPanel) {
                        const rows = targetPanel.querySelectorAll('.amc-price-list__tbody tr');
                        rows.forEach(row => {
                            row.style.display = '';
                        });
                    }
                }
            }
        });
    });

    // Mobile search icon click - show input bar and hide icon
    const searchIcons = section.querySelectorAll('.amc-price-list__search-icon-mobile');
    searchIcons.forEach(icon => {
        icon.addEventListener('click', () => {
            const mobileTopBar = icon.closest('.amc-price-list__mobile-top-bar');
            if (mobileTopBar) {
                mobileTopBar.classList.add('mobile-search-active');
            }
        });
    });

    // Mobile search close icon click - hide input bar and show search icon
    const closeIcons = section.querySelectorAll('.amc-price-list__search-close-mobile');
    closeIcons.forEach(closeIcon => {
        closeIcon.addEventListener('click', () => {
            const mobileTopBar = closeIcon.closest('.amc-price-list__mobile-top-bar');
            if (mobileTopBar) {
                mobileTopBar.classList.remove('mobile-search-active');
                // Clear the search input
                const searchInput = mobileTopBar.querySelector('.amc-price-list__search');
                if (searchInput) {
                    searchInput.value = '';
                    // Reset table rows visibility
                    const targetPanel = mobileTopBar.closest('.amc-price-list__panel');
                    if (targetPanel) {
                        const rows = targetPanel.querySelectorAll('.amc-price-list__tbody tr');
                        rows.forEach(row => {
                            row.style.display = '';
                        });
                    }
                }
            }
        });
    });
});